import { useCallback, useEffect, useState } from 'react';
import type { User } from '@supabase/supabase-js';
import App from '../App';
import { supabase } from '../lib/supabase';
import { onTurnstileReset, setTurnstileToken } from '../lib/turnstileToken';
import { TurnstileChallenge } from './TurnstileChallenge';

export function GuestCaptchaShell() {
  const [user, setUser] = useState<User | null>(null);
  const [captchaRevision, setCaptchaRevision] = useState(0);
  const siteKey = import.meta.env.VITE_TURNSTILE_SITE_KEY?.trim() ?? '';

  const handleCaptchaToken = useCallback((token: string | null) => {
    setTurnstileToken(token);
  }, []);

  useEffect(() => {
    let active = true;

    void supabase.auth.getSession().then(({ data }) => {
      if (active) setUser(data.session?.user ?? null);
    });

    const { data: subscription } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });

    return () => {
      active = false;
      subscription.subscription.unsubscribe();
    };
  }, []);

  useEffect(
    () =>
      onTurnstileReset(() => {
        setCaptchaRevision((current) => current + 1);
      }),
    [],
  );

  return (
    <>
      <App />
      {!user && siteKey ? (
        <aside className="turnstile-launch-panel" aria-label="Human verification">
          <strong>Human verification</strong>
          <small>Complete this once before creating a new guest workspace.</small>
          <TurnstileChallenge
            key={captchaRevision}
            siteKey={siteKey}
            onToken={handleCaptchaToken}
          />
        </aside>
      ) : null}
    </>
  );
}
